import HeroSection from "../../../components/hero-section/HeroSection";
import bgImg from "../../../resources/images/hfi-images/Svit-Video-Production-1.webp";
import AccessibilityPlan from "../../../components/footer/accessibility-plan/accessibilityPlan";

const AccessibilityPlanPage = () => {
  return (
    <div>
      <HeroSection
        title={""}
        subtitle={"Accessibility Plan"}
        backgroundImage={bgImg}
      />

      <AccessibilityPlan />
    </div>
  );
};

export default AccessibilityPlanPage;
